import { primary } from "./primary";
import { secondary } from "./secondary";
import { palette as CommonPalette } from "../../common";
import { leftMenu } from "./leftMenu";

// import { error } from "./error";
// import { info } from "./info";
// import { success } from "./success";
// import { warning } from "./warning";
// import { tertiary } from "./tertiary";

export const palette = {
  ...CommonPalette,
  primary: {
    ...CommonPalette.primary,
    ...primary,
    main: primary[900],
  },
  secondary: {
    ...CommonPalette.secondary,
    ...secondary,
    main: secondary[700],
  },
  leftMenu: {
    ...CommonPalette.leftMenu,
    ...leftMenu,
  },
  // error: {
  //   main: error[800],
  //   ...error
  // },
  // warning: {
  //   main: warning[800],
  //   ...warning
  // },
  // info: {
  //   main: info[800],
  //   ...info
  // },
  // success: {
  //   main: success[800],
  //   ...success
  // },
  // tertiary: tertiary,
};
